export class AudienciaCampania {
    idAudiencia: string;
    aliasAudiencia: string;
    descripcion: string;
    estado: string;

    constructor(idAudiencia: string, aliasAudiencia: string, descripcion: string, estado: string) {
      this.idAudiencia = idAudiencia;
      this.aliasAudiencia = aliasAudiencia;
      this.descripcion = descripcion;
      this.estado = estado;
    }
  
    // Optional: Add methods for behavior if needed
    isActive() {
      return this.estado.toLowerCase() === "active";
    }
  
    toString() {
      return `${this.aliasAudiencia}: ${this.descripcion} (${this.estado})`;
    }
  }